import { isAxiosError } from 'axios';
import { proxyClient } from '@api/client';
import { GrantWebsiteProxyAccessDto } from '@api/website-proxy/Api';

export const grantWebsiteProxyAccess = async (
  data: GrantWebsiteProxyAccessDto
) => {
  try {
    await proxyClient.websiteProxy.websiteProxyControllerGrantAccess(data);
    return true;
  } catch (err) {
    if (isAxiosError(err) && typeof err.response?.data?.error === 'string') {
      return { error: err.response.data.error };
    }
    return { error: (err as Error).message };
  }
};
